import axios from "axios";
import { createEffect, createStore } from "effector";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { unpackServerData } from "../../../common/functions";
import { getUuidAndSession } from "../../../common/localStorage";
interface IForms {
    exist: boolean,
    message: string,
    pdfFile: string,
    totalByMonthId: string

}
interface IBillForm {
    accountId: number
    typeName: string
    docType: string
    date: string
}

interface IAct {
    accountId: number
    actId: string
    date:string
}
export const queryGetActs = createEffect<number, IForms[]>();
export const queryDownloadAct = createEffect<IAct, null>()
export const queryGetActRequest = createEffect()
export const queryGetBillForm = createEffect<IBillForm, string>()
export const $reconciliationActs = createStore<IForms[]>([])

$reconciliationActs.on(queryGetActs.doneData, (_, curr) => curr)


queryGetActs.use((accountId) =>
    axios.post("https://izba.kras-abs.ru/api/v3/charge/acts", {
        ...getUuidAndSession(),
        accountId: accountId,
    }, {
        headers: {
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Custom-User-Agent": getCustomUserAgent()
        }
    }).then((resp) => {
        let data = unpackServerData(resp.data, "forms")
        // if(data.failMsg != '') {
        return data.data as IForms[]
        // }
        // return {transactions: [], transactionsByMonth: []} as IQueryTransactionsResult
    }).catch(e => {
        let msg = e.message
        if (e.response && e.response.data) {
            let data = unpackServerData(e.response.data)
            if (data.failMsg != "") {
                msg = data.failMsg
            }
        }
        return e.response as IForms[]
    })
);
queryGetActRequest.use((accountId) =>
    axios.post("https://izba.kras-abs.ru/api/v3/charge/acts_request", {
        ...getUuidAndSession(),
        accountId: accountId,
    }, {
        headers: {
            "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Custom-User-Agent": getCustomUserAgent()
        }
    }).then((resp) => {
        // let data = unpackServerData(resp.data, "forms")
        // console.log(resp, data)
        return resp.data.queue
    }).catch(e => {
        let msg = e.message
        if (e.response && e.response.data) {
            let data = unpackServerData(e.response.data)
            if (data.failMsg != "") {
                msg = data.failMsg
            }
        }
        return e.response as IForms[]
    })
);

queryGetBillForm.use((params) => {
    console.log("params",params)
    // let filename = `Отчет по ${params.date}.pdf`;
    // let filename = `${params.docType} ${params.typeName}.pdf`;
    let xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.onreadystatechange = function () {
        var a;
        let filename="";
        if(xmlHttpRequest.getResponseHeader('content-disposition'))
        filename = xmlHttpRequest.getResponseHeader('content-disposition')!.split('filename=')[1].split(';')[0]
        filename= filename.split('+').join(' ');    
        // console.log(filename)
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
            if (xmlHttpRequest.response.type === "application/pdf") {
                a = document.createElement('a');
                a.href = window.URL.createObjectURL(xmlHttpRequest.response);
                a.download = decodeURI(filename).split('"').join('').split('%2C').join(',');
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
            }
            else {
                alert("Что-то пошло не так")
            }
        }
    };
    xmlHttpRequest.open("POST", 'https://izba.kras-abs.ru/api/v3/charge/billForms');
    xmlHttpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    xmlHttpRequest.setRequestHeader("Custom-User-Agent", getCustomUserAgent());
    xmlHttpRequest.responseType = 'blob';
    xmlHttpRequest.send(JSON.stringify({
        ...getUuidAndSession(),
        "accountId": params.accountId,
        "billID": params.typeName,
        "docType": params.docType
    }));
    return 'hello'
}
);
queryDownloadAct.use((params: IAct) => {
    let filename = `Акт сверки от ${params.date}.pdf`;
    let xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.onreadystatechange = function () {
        var a;
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
            if (xmlHttpRequest.response.type === "application/pdf") {
                a = document.createElement('a');
                a.href = window.URL.createObjectURL(xmlHttpRequest.response);
                a.download = filename;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
            }
            else {
                alert("Что-то пошло не так")
            }
        }
    };
    xmlHttpRequest.open("POST", 'https://izba.kras-abs.ru/api/v3/charge/getAct');
    xmlHttpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    xmlHttpRequest.setRequestHeader("Custom-User-Agent", getCustomUserAgent());
    xmlHttpRequest.responseType = 'blob';
    xmlHttpRequest.send(JSON.stringify({
        ...getUuidAndSession(),
        "accountId": params.accountId,
        "actId":params.actId
    }));
    return null
}
);